<template>
  <v-alert
    v-if="showBanner"
    icon="icon-warning-xs"
    color="indigo-sky"
    class="mb-6 py-1 px-2 text-primary"
  >
    <div class="body2" v-html="$t(`setupHub.conditionalBanner.${dependantStepName}`)"></div>
    <div
      class="cursor-pointer text-decoration-underline text-primary text--semibold mt-1"
      @click="onActionClick()"
    >
      {{ $t(`setupHub.subSteps.${dependantStepName}.title`) }}
    </div>
  </v-alert>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { type SetupHubStepItem, useSetupHubStore } from "@/_store/setup-hub.module.ts";
import { SetupHubStatus, type SetupHubStep } from "@/constants/setup-hub.ts";

export default defineComponent({
  props: {
    subStep: {
      type: Object as PropType<SetupHubStepItem>,
      required: true,
    },
  },
  emits: ["switch-to-step"],
  setup(props, { emit }) {
    const { findStep } = useSetupHubStore();

    const notCompletedDependantSteps = computed(() => {
      return props.subStep.dependentSteps
        .map((step: SetupHubStep) => {
          return findStep(step);
        })
        .filter((s: SetupHubStepItem | null) => {
          return s && s.status !== SetupHubStatus.COMPLETED;
        });
    });

    const showBanner = computed(() => {
      return notCompletedDependantSteps.value.length > 0;
    });

    const dependantStep = computed(() => {
      return notCompletedDependantSteps.value[0];
    });

    const dependantStepName = computed(() => {
      return showBanner.value ? dependantStep.value?.step : "";
    });

    const onActionClick = () => {
      emit("switch-to-step", dependantStep.value?.step);
    };

    return {
      showBanner,
      dependantStepName,
      onActionClick,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-alert__prepend) {
  .icon-warning-xs::before {
    color: rgb(var(--v-theme-primary));
  }
  & {
    margin-right: 5px !important;
  }
}
</style>
